module.exports = __webpack_public_path__ + "img/dishPlaceHolder.9730dce7.svg";